import { NgModule } from '@angular/core';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Renderer } from '@angular/core';
import { TamasAlunoService } from '../tamas-aluno.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaInputDialog } from '../alerta-input';
import { AlertaConfirmDialog } from '../alerta-confirm';
import { Location } from '@angular/common';
import { AlertaTermosDialog } from '../alerta-termos';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-dashboard-refeicao',
  templateUrl: './dashboard-refeicao.component.html',
  styleUrls: ['./dashboard-refeicao.component.css']
})
export class DashboardRefeicaoComponent implements OnInit {
  @ViewChild("treinohead") exc1p: ElementRef;
  hideLoginLoad: boolean = true;
  meusDados: any = '';
  dadosRecuperar: any = '';
  tentativasFail: any = 0;
  isPassword: boolean = true;
  idCliente: any = 0;
  fcmToken: any = '';
  idPaciente: any = '';
  idPlano: any = 0;
  titexc: any = '';
  qtdseries: any = '';
  qtdrep: any = '';
  tempodescanso: any = '';
  obsexc: any = '';
  editando: boolean = false;
  idEditando: any = 0;
  refeicaoOE: any = 0;
  arrExtras: any[] = [];
  arrRefeicoes: any[] = []
  arrDias: any[] = [];
  arrOpcoesRef: any[] = [];
  arrOpcoesRefEdit: any[] = [];
  horarioRef: any = '';
  titref: any = '';
  obsref: any = '';
  opcao1: any = '';
  contadorFake: any = 0;
  showModelos: boolean = false;
  modeloplano: any = '';
  nomePlano: any = '';
  arrModelos: any[] = [];
  filteredOptions: Observable<string[]>;
  myControl = new FormControl();
  listaNomesRefeicoes: any[] = [];
  cooldown: any = 0;
  pEnviado: boolean = false;
  separacaoDot: boolean = true;
  constructor(private route: ActivatedRoute, private renderer: Renderer, public tmaService: TamasAlunoService, public router: Router, public dialog: MatDialog, private _location: Location) { }

  ngOnInit() {
    this.tmaService.eventoFS(true);
    this.idPaciente = this.route.snapshot.paramMap.get('idpaciente');
    this.idPlano = this.route.snapshot.paramMap.get('idplano');

    this.arrDias.push({ Id: 7, Dia: "Todos os dias", ck: false, enable: true });
    this.arrDias.push({ Id: 1, Dia: "Segunda-Feira", ck: false, enable: true });
    this.arrDias.push({ Id: 2, Dia: "Terça-Feira", ck: false, enable: true });
    this.arrDias.push({ Id: 3, Dia: "Quarta-Feira", ck: false, enable: true });
    this.arrDias.push({ Id: 4, Dia: "Quinta-Feira", ck: false, enable: true });
    this.arrDias.push({ Id: 5, Dia: "Sexta-Feira", ck: false, enable: true });
    this.arrDias.push({ Id: 6, Dia: "Sábado", ck: false, enable: true });
    this.arrDias.push({ Id: 0, Dia: "Domingo", ck: false, enable: true });
    //fake
    // this.arrTreinos.push({Id: 1, NomeTreino: 'Treino A - Dorsal'});
    // this.arrTreinos.push({Id: 2, NomeTreino: 'Treino B - Bíceps e Tríceps'});
    // this.arrTreinos.push({Id: 3, NomeTreino: 'Treino C - Aeróbicos HIT'});
    //this.nomePlano = 'Dieta Cutting';
    this.listaNomesRefeicoes.push({ 'refeicao': 'Café da manhã' });
    this.listaNomesRefeicoes.push({ 'refeicao': 'Colação' });
    this.listaNomesRefeicoes.push({ 'refeicao': 'Almoço' });
    this.listaNomesRefeicoes.push({ 'refeicao': 'Lanche da tarde' });
    this.listaNomesRefeicoes.push({ 'refeicao': 'Jantar' });
    this.listaNomesRefeicoes.push({ 'refeicao': 'Ceia' });

    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

    this.carregarInfoPlano();
  }
  ngOnDestroy() {
    console.log("destroy");
    //this.tmaService.eventoFS(false);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.listaNomesRefeicoes.filter(option => option.refeicao.toLowerCase().includes(filterValue));
  }


  changeDOT() :void{
    this.separacaoDot = !this.separacaoDot;
  }

  onKeydownEvent(event: KeyboardEvent): void {
    if (this.separacaoDot) {
      //opc_0
      var posStart = this.renderer.selectRootElement("#opc_0").selectionStart;
      //console.log(posStart);
      //console.log(this.renderer.selectRootElement("#opc_0").value.length);
      if (event.key == 'Enter') {
        setTimeout(() => {
          if (posStart + 1 == this.renderer.selectRootElement("#opc_0").value.length) {
            console.log("no final");
            this.opcao1 += '• ';
          }
          else {
            //geramos a quebra e alteramos posição do cursor
            console.log("no meio");
            var txtAtual = this.opcao1;
            this.renderer.selectRootElement("#opc_0").value = txtAtual.substring(0, posStart) + "\r" + "• " + "\r" + txtAtual.substring(posStart + 1, txtAtual.length);
            this.renderer.selectRootElement("#opc_0").selectionEnd = posStart + 3;
          }

        }, 100);
      }

      if (this.opcao1 == '') {
        this.opcao1 = '• '
      }
    }

  }


  onKeydownEvent2(event: KeyboardEvent, idbox: any): void {

    if(this.separacaoDot){
      var qIndex = this.arrExtras.findIndex(x => x.valor == idbox);
      //console.log(this.renderer.selectRootElement('#' + idbox).selectionStart);
      //console.log(this.arrExtras[qIndex].texto);
      var posStart = this.renderer.selectRootElement('#' + idbox).selectionStart;
      var txtAtual = this.renderer.selectRootElement('#' + idbox).value;
  
      if (event.key == 'Enter') {
        setTimeout(() => {
          //dot apos o enter
          if (this.renderer.selectRootElement('#' + idbox).value.length == this.renderer.selectRootElement('#' + idbox).selectionStart) {
            //não há texto depois da posição do cursor
            console.log("no final");
            this.renderer.selectRootElement('#' + idbox).value += '• ';
          }
          else {
            console.log("no meio");
            //há texto após cursor, fazemos a adição do ponto e mantemos o cursor
            this.renderer.selectRootElement('#' + idbox).value = txtAtual.substring(0, posStart) + "\r" + "• " + "\r" + txtAtual.substring(posStart + 1, txtAtual.length);
            this.renderer.selectRootElement('#' + idbox).selectionEnd = posStart + 3;
  
          }
  
        }, 100);
      }
      else {
        //caso não seja enter, verificamos se é o primeiro input, se for adicionar o dot
        if (this.renderer.selectRootElement('#' + idbox).value == '') {
          this.renderer.selectRootElement('#' + idbox).value = '• '
        }
        else {
          //this.arrExtras[qIndex].texto += event.key;
        }
      }
    }
   
  }


  carregarInfoPlano() {
    this.hideLoginLoad = false;
    var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idpaciente=' + this.idPaciente + '&idplano=' + this.idPlano;
    this.tmaService.getInfoPlanoAli(dadosIn)
      .subscribe((qRes) => {
        this.hideLoginLoad = true;
        console.log(qRes);
        if (qRes['res'] == 'ok') {
          this.nomePlano = qRes['nomeplano'];
          this.arrRefeicoes = qRes['objPlano'];
          this.arrModelos = qRes['objModelos'];
          this.pEnviado = qRes['already'];
          this.cooldown = qRes['cooldown'];
        }
        else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Ocorreu um erro ao obter informações deste plano. Tente novamente", iconAlerta: 'warning' }
          });
        }
      },
        (error) => {
          this.hideLoginLoad = true;
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
          });
        })
  }

  showMod(): void {
    this.showModelos = true;
    //server side preencher dd
  }

  closeMod(): void {
    this.showModelos = false;
    this.modeloplano = '';
  }

  useMod(): void {
    //server side importar refeicoes
    if (this.modeloplano != '') {
      const importMod = this.dialog.open(AlertaConfirmDialog, {
        //width: '250px',
        disableClose: true,
        data: { iconAlerta: "warning", tituloAlerta: "Importar Modelo", textoAlerta: "Confirma a utilização deste modelo para o plano alimentar atual?", textoCancel: 'Não', textoConfirm: "SIM" }
      });

      importMod.afterClosed().subscribe(result => {
        console.log(result);
        if (result) {
          let customParams = {
            //lista: localStorage.getItem('turboCart'),
            email: this.tmaService.hcEmail,
            senha: this.tmaService.hcSenha,
            idpaciente: this.idPaciente,
            idplano: this.idPlano,
            idmodelo: this.modeloplano
          };

          this.hideLoginLoad = false;
          this.tmaService.importarModeloAli(customParams).subscribe((qRes) => {
            this.hideLoginLoad = true;
            console.log(qRes);
            if (qRes['res'] == 'ok') {
              this.showModelos = false;
              this.modeloplano = '';
              this.carregarInfoPlano();
            }
            else {
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Ocorreu um erro adicionar esta refeição. Tente novamente", iconAlerta: 'warning' }
              });
            }
          },
            (error) => {
              this.hideLoginLoad = true;
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
              });
            })
        }
      })
    }
    else {
      const selecMod = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Por favor escolha um modelo para realizar a importação", iconAlerta: 'warning' }
      });
    }
  }


  salvarModelo(): void {
    const novoAlertaIn = this.dialog.open(AlertaInputDialog, {
      disableClose: true,
      data: { tituloAlerta: "Título do Modelo ", textoAlerta: "Dê um título e clique em Salvar", tipoInput: 'text', textoCancel: 'cancelar', textoConfirm: 'Salvar', valorInput: '', nomeInput: 'nomemodelo', beFocused: true }
    })
    novoAlertaIn.afterClosed().subscribe((result) => {
      console.log(result);
      if (result !== false) {
        //server side
        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          idpaciente: this.idPaciente,
          idplano: this.idPlano,
          nomeModelo: result
        };

        this.hideLoginLoad = false;
        this.tmaService.salvarModeloAli(customParams).subscribe((qRes) => {
          this.hideLoginLoad = true;
          console.log(qRes);
          if (qRes['res'] == 'ok') {

          }
          else {
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Ocorreu um erro adicionar esta refeição. Tente novamente", iconAlerta: 'warning' }
            });
          }
        },
          (error) => {
            this.hideLoginLoad = true;
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
            });
          })
      }
    });
  }

  jaEnviado(): void {
    if (this.cooldown <= 3) {
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        width: '300px',
        data: { textoAlerta: "Este plano já foi enviado anteriormente. Caso necessite, você ainda pode inserir/editar as refeições que serão atualizados automaticamente para o paciente.", iconAlerta: 'done_outline' }
      });
    }
    else {
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        width: '300px',
        data: { textoAlerta: "Este plano já foi enviado anteriormente. Não é mais possível realizar alterações.", iconAlerta: 'warning' }
      });
    }

  }


  envP(): void {
    const enviarP = this.dialog.open(AlertaConfirmDialog, {
      //width: '250px',
      disableClose: true,
      data: { iconAlerta: "warning", tituloAlerta: "Atenção", textoAlerta: "Após o envio você terá até 3 dias para editar/inserir novas refeições, depois desse prazo não será possível alterações.<br> Confirma o envio deste plano alimentar? ", textoCancel: 'Não', textoConfirm: "SIM" }
    });

    enviarP.afterClosed().subscribe(result => {
      console.log(result);
      if (result) {
        //server side
        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          idpaciente: this.idPaciente,
          idplano: this.idPlano
        };
        this.hideLoginLoad = false;
        this.tmaService.enviarPlanoAli(customParams).subscribe((qRes) => {
          this.hideLoginLoad = true;
          console.log(qRes);
          if (qRes['res'] == 'ok') {
            const sendSuccess = this.dialog.open(AlertaConfirmDialog, {
              //width: '250px',
              disableClose: true,
              data: { iconAlerta: "done_outline", tituloAlerta: "Enviado", textoAlerta: "O plano alimentar foi enviado com sucesso!", textoConfirm: "OK" }
            });

            sendSuccess.afterClosed().subscribe(result => {
              this.voltar();
            });
          }
          else {
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Ocorreu um erro ao enviar este plano. Tente novamente", iconAlerta: 'warning' }
            });
          }
        },
          (error) => {
            this.hideLoginLoad = true;
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
            });
          })

        // this.router.navigate(['/dashboard/add-treino/' + this.nickPaciente + '/' + this.idPlano ]);
      }
    })


  }
  excluirP(): void {
    const excluirPlano = this.dialog.open(AlertaConfirmDialog, {
      //width: '250px',
      disableClose: true,
      data: { iconAlerta: "delete_forever", tituloAlerta: "Excluir", textoAlerta: "Confirma a exclusão deste plano?", textoCancel: 'Não', textoConfirm: "SIM" }
    });

    excluirPlano.afterClosed().subscribe(result => {
      console.log(result);
      if (result) {
        //server side
        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          idpaciente: this.idPaciente,
          idplano: this.idPlano
        };
        this.hideLoginLoad = false;
        this.tmaService.excluirPlanoA(customParams).subscribe((qRes) => {
          this.hideLoginLoad = true;
          console.log(qRes);
          if (qRes['res'] == 'ok') {
            this.voltar();
          }
          else {
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Ocorreu um erro ao excluir este plano. Tente novamente", iconAlerta: 'warning' }
            });
          }
        },
          (error) => {
            this.hideLoginLoad = true;
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
            });
          })

        // this.router.navigate(['/dashboard/add-treino/' + this.nickPaciente + '/' + this.idPlano ]);
      }
    })
  }

  changeCk(IdDia: any, qStatus: any): void {
    console.log(IdDia);
    console.log(qStatus);
    if (!this.editando) {
      if (IdDia == 7) {
        //todos
        this.arrDias.forEach(element => {
          if (element.Id !== 7) {
            element.ck = !qStatus;
          }
        });
        //this.arrDias.find(x => x.Id == 7).ck = true;
      }
      else {
        this.arrDias.find(x => x.Id == 7).ck = false;
        this.arrDias.find(x => x.Id == IdDia).ck = qStatus;
      }
    }

  }

  addOE(): void {
    var opFake = 0;
    opFake = this.arrExtras.length + 1;
    this.arrExtras.push({ valor: 'opc_' + opFake, texto: '' });
    console.log(this.arrExtras);
  }
  removeOE(qValor: any): void {
    var meuIndex = this.arrExtras.findIndex(x => x.valor == qValor);
    this.arrExtras.splice(meuIndex, 1);
  }

  incluirRefeicao(): void {

    if (this.cooldown > 3 && this.pEnviado) {
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Este plano já foi enviado há mais de 3 dias e não é possível adicionar mais refeições", iconAlerta: 'warning' }
      });
    }
    else {
      console.log(this.horarioRef);
      console.log(this.arrDias);
      console.log(this.renderer.selectRootElement('#opc_0').value);
      if (!this.arrDias.find(x => x.ck == true)) {
        //escolher dia
        const alertaDia = this.dialog.open(AlertaSimplesDialog, {
          //width: '250px',
          disableClose: true,
          data: { iconAlerta: "", tituloAlerta: 'Atenção', textoAlerta: 'Escolha pelo menos um dia da semana', textoCancel: '', textoConfirm: "OK" }
        });
      }
      else {
        //server side
        this.arrOpcoesRef.push({ Titulo: 'Opção 1', Descritivo: this.opcao1 });
        var qNumber = 1;
        this.arrExtras.forEach(qIdx => {
          console.log(qIdx);
          qNumber++;
          console.log(this.renderer.selectRootElement('#' + qIdx.valor).value);
          this.arrOpcoesRef.push({ Titulo: 'Opção ' + qNumber, Descritivo: this.renderer.selectRootElement('#' + qIdx.valor).value });
        });

        var arrDSelec = [];
        this.arrDias.forEach(qElement => {
          if (qElement.Id !== 7) {
            if (qElement.ck) {
              arrDSelec.push({ dia: qElement.Id });
            }
          }
        });

        var mDias = JSON.stringify(arrDSelec);
        var mOpcoes = JSON.stringify(this.arrOpcoesRef);
        let customParams = {
          //lista: localStorage.getItem('turboCart'),
          email: this.tmaService.hcEmail,
          senha: this.tmaService.hcSenha,
          idpaciente: this.idPaciente,
          idplano: this.idPlano,
          opcoesRef: mOpcoes,
          diasRef: mDias,
          horaRef: this.horarioRef,
          nomeRef: this.titref,
          obsref: this.obsref
        };

        this.hideLoginLoad = false;
        this.tmaService.criarRefeicao(customParams).subscribe((qRes) => {
          this.hideLoginLoad = true;
          console.log(qRes);
          if (qRes['res'] == 'ok') {
            //this.router.navigate(['dashboard/refeicao/' + this.idPaciente + '/' +  qRes['idplano'] ]);
            // var qIndex = this.arrRefeicoes.findIndex(x => x.Id == this.idEditando);
            // this.arrRefeicoes.splice(qIndex, 1);

            this.arrOpcoesRef = [];
            this.editando = false;
            this.titref = '';
            this.opcao1 = '';
            this.arrExtras = [];
            this.obsref = '';
            this.changeDias(true);
            this.carregarInfoPlano();
          }
          else {
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Ocorreu um erro adicionar esta refeição. Tente novamente", iconAlerta: 'warning' }
            });
          }
        },
          (error) => {
            this.hideLoginLoad = true;
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose: true,
              data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
            });
          })
      }



      // this.arrOpcoesRef.push({ Opcao: this.opcao1});
      // this.arrExtras.forEach(qIdx => {
      //   console.log(qIdx);
      //   console.log(this.renderer.selectRootElement('#'  + qIdx.valor).value);
      //   this.arrOpcoesRef.push({ Opcao: this.renderer.selectRootElement('#'  + qIdx.valor).value});

      // });
      // var notID = 0;

      // this.arrDias.forEach(qElement => {
      //   if (qElement.Id !== 7) {
      //     if (qElement.ck) {
      //       this.contadorFake += 1;
      //       this.arrRefeicoes.push({Id: this.contadorFake,  DiaSemana: qElement.Id, Horario: this.horarioRef, NomeRefeicao: this.titref, Obs: this.obsref, Opcoes: this.arrOpcoesRef });
      //     }
      //   }
      // });
      // this.arrOpcoesRef = [];
      // this.titref = '';
      // this.opcao1 = '';
      // this.arrExtras = [];
      // this.obsref = '';
      // console.log(this.arrRefeicoes);
    }


  }

  atualizarRefeicao(): void {
    if (this.cooldown > 3 && this.pEnviado) {
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Este plano já foi enviado há mais de 3 dias e não é possível adicionar mais refeições", iconAlerta: 'warning' }
      });
    }
    else {
      //server side
      this.arrOpcoesRef.push({ Titulo: 'Opção 1', Descritivo: this.opcao1 });
      var qNumber = 1;
      this.arrExtras.forEach(qIdx => {
        console.log(qIdx);
        qNumber++;
        console.log(this.renderer.selectRootElement('#' + qIdx.valor).value);
        this.arrOpcoesRef.push({ Titulo: 'Opção ' + qNumber, Descritivo: this.renderer.selectRootElement('#' + qIdx.valor).value });
      });

      var mOpcoes = JSON.stringify(this.arrOpcoesRef);
      let customParams = {
        //lista: localStorage.getItem('turboCart'),
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        idpaciente: this.idPaciente,
        idplano: this.idPlano,
        opcoesRef: mOpcoes,
        horaRef: this.horarioRef,
        nomeRef: this.titref,
        obsref: this.obsref,
        idrefeicao: this.idEditando
      };

      this.hideLoginLoad = false;
      this.tmaService.editarRefeicao(customParams).subscribe((qRes) => {
        this.hideLoginLoad = true;
        console.log(qRes);
        if (qRes['res'] == 'ok') {
          //this.router.navigate(['dashboard/refeicao/' + this.idPaciente + '/' +  qRes['idplano'] ]);
          var qIndex = this.arrRefeicoes.findIndex(x => x.Id == this.idEditando);
          this.arrRefeicoes.splice(qIndex, 1);
          this.arrOpcoesRef = [];
          this.editando = false;

          this.titref = '';
          this.opcao1 = '';
          this.arrExtras = [];
          this.obsref = '';
          this.changeDias(true);
          this.carregarInfoPlano();
        }
        else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Ocorreu um erro editar esta refeição. Tente novamente", iconAlerta: 'warning' }
          });
        }
      },
        (error) => {
          this.hideLoginLoad = true;
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
          });
        })
    }





    //hardcoded
    // var qIndex = this.arrRefeicoes.findIndex(x => x.Id == this.idEditando);
    // this.arrRefeicoes.splice(qIndex, 1);

    // this.arrOpcoesRef.push({ Opcao: this.opcao1});
    // this.arrExtras.forEach(qIdx => {
    //   console.log(qIdx);
    //   console.log(this.renderer.selectRootElement('#'  + qIdx.valor).value);
    //   this.arrOpcoesRef.push({ Opcao: this.renderer.selectRootElement('#'  + qIdx.valor).value});

    // });

    // var notID = 0;

    // this.arrDias.forEach(qElement => {
    //   if (qElement.Id !== 7) {
    //     if (qElement.ck) {
    //       this.contadorFake += 1;
    //       this.arrRefeicoes.push({Id: this.contadorFake,  DiaSemana: qElement.Id, Horario: this.horarioRef, NomeRefeicao: this.titref, Obs: this.obsref, Opcoes: this.arrOpcoesRef });
    //     }
    //   }
    // });



  }
  cancelarEdit(): void {
    this.arrOpcoesRef = [];
    this.titref = '';
    this.opcao1 = '';
    this.arrExtras = [];
    this.obsref = '';
    this.changeDias(true);
    this.editando = false;
  }
  duplicarRef(): void {
    //same as incluir, w/o clear fields

    if (!this.arrDias.find(x => x.ck == true)) {
      //escolher dia
      const alertaDia = this.dialog.open(AlertaSimplesDialog, {
        //width: '250px',
        disableClose: true,
        data: { iconAlerta: "", tituloAlerta: 'Atenção', textoAlerta: 'Escolha pelo menos um dia da semana', textoCancel: '', textoConfirm: "OK" }
      });
    }
    else {
      this.arrOpcoesRef.push({ Opcao: this.opcao1 });
      this.arrExtras.forEach(qIdx => {
        console.log(qIdx);
        console.log(this.renderer.selectRootElement('#' + qIdx.valor).value);
        this.arrOpcoesRef.push({ Opcao: this.renderer.selectRootElement('#' + qIdx.valor).value });

      });
      var notID = 0;

      this.arrDias.forEach(qElement => {
        if (qElement.Id !== 7) {
          if (qElement.ck) {
            this.contadorFake += 1;
            this.arrRefeicoes.push({ Id: this.contadorFake, DiaSemana: qElement.Id, Horario: this.horarioRef, NomeRefeicao: this.titref, Obs: this.obsref, Opcoes: this.arrOpcoesRef });
          }
        }
      });
      this.arrOpcoesRef = [];
      this.changeDias(true);
      this.editando = false;
    }
  }

  changeDias(condicao: any): void {
    this.arrDias.forEach(qIx => {
      qIx.enable = condicao;
    });
  }

  goAvaliacao(): void {
    this.router.navigate(['/dashboard/paciente/' + this.idPaciente + '/avaliacao/1']);
  }

  addTreino(): void {
    const addNT = this.dialog.open(AlertaConfirmDialog, {
      //width: '250px',
      disableClose: true,
      data: { iconAlerta: "", tituloAlerta: "Novo Treino", textoAlerta: '', textoCancel: 'Cancelar', textoConfirm: "OK", nTreino: true }
    });
    addNT.afterClosed().subscribe(result => {
      console.log(result);
      if (result !== false && result !== '') {
        //this.arrTreinos.push({Id: 4, NomeTreino: result});
      }
    })
  }

  removerExc(idExc: any): void {
    if (this.cooldown > 3 && this.pEnviado) {
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { textoAlerta: "Este plano já foi enviado há mais de 3 dias e não é possível excluir as refeições", iconAlerta: 'warning' }
      });
    }
    else {
      const remExc = this.dialog.open(AlertaConfirmDialog, {
        //width: '250px',
        disableClose: true,
        data: { iconAlerta: "delete_forever", tituloAlerta: "Excluir", textoAlerta: "Confirma a exclusão desta refeição?", textoCancel: 'Cancelar', textoConfirm: "SIM" }
      });

      remExc.afterClosed().subscribe(result => {
        console.log(result);
        if (result) {
          //server side
          let customParams = {
            //lista: localStorage.getItem('turboCart'),
            email: this.tmaService.hcEmail,
            senha: this.tmaService.hcSenha,
            idpaciente: this.idPaciente,
            idplano: this.idPlano,
            idrefeicao: idExc
          };

          this.hideLoginLoad = false;
          this.tmaService.excluirRefeicao(customParams).subscribe((qRes) => {
            this.hideLoginLoad = true;
            console.log(qRes);
            if (qRes['res'] == 'ok') {
              this.carregarInfoPlano();
            }
            else {
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Ocorreu um erro excluir esta refeição. Tente novamente", iconAlerta: 'warning' }
              });
            }
          },
            (error) => {
              this.hideLoginLoad = true;
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose: true,
                data: { textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
              });
            })
          // var qIndex = this.arrRefeicoes.findIndex(x => x.Id == idExc);
          // this.arrRefeicoes.splice(qIndex, 1);
        }
      })
    }

  }

  editExc(idExc: any): void {
    //inserir os parâmetros no input
    //this.titexc = "Remada Baixa com puxador fechado";
    this.arrExtras = [];
    var eIndex = this.arrRefeicoes.findIndex(x => x.Id == idExc);
    console.log(idExc);
    console.log(eIndex);
    console.log(this.arrRefeicoes[eIndex]);
    console.log(this.arrRefeicoes[eIndex].Opcoes);

    this.titref = this.arrRefeicoes[eIndex].NomeRefeicao;
    this.horarioRef = this.arrRefeicoes[eIndex].Horario;
    this.obsref = this.arrRefeicoes[eIndex].Obs;
    this.arrDias.forEach(diaElem => {
      diaElem.ck = false;
    });
    this.arrDias.find(x => x.Id == this.arrRefeicoes[eIndex].DiaSemana).ck = true;

    this.arrOpcoesRefEdit = this.arrRefeicoes[eIndex].Opcoes;
    var opFake = 0;
    this.arrOpcoesRefEdit.forEach((iElement, qIdx) => {
      if (qIdx == 0) {
        this.opcao1 = iElement.Opcao;
      }
      else {
        opFake = this.arrExtras.length + 1;
        this.arrExtras.push({ valor: 'opc_' + opFake, texto: iElement.Opcao });
        //this.renderer.selectRootElement('#opc_'  + opFake).value = iElement.Opcao;
      }

    });


    //console.log(this.arrExtras);

    this.editando = true;
    this.idEditando = idExc;
    this.changeDias(false);
    //this.exc1p.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  incluirExc(): void {
    //this.arrRefeicoes.push({Id: 1, Descritivo: 'Remada Frontal puxador aberto', Observacoes: 'Até a falha', NumSeries: 3, NumRepeticoes: 8, TempoDescanso: 45});
    //server side
    if (this.editando) {
      //atualizar 
      var incIndex = this.arrRefeicoes.findIndex(x => x.Id == this.idEditando);
      this.arrRefeicoes[incIndex].Descritivo = this.titexc;
      this.editando = false;
    }
    else {
      //new
      var fakeId = 0;
      fakeId = this.arrRefeicoes.length + 1;
      this.arrRefeicoes.push({ Id: fakeId, Descritivo: this.titexc, Observacoes: this.obsexc, NumSeries: this.qtdseries, NumRepeticoes: this.qtdrep, TempoDescanso: this.tempodescanso });
      this.titexc = '';
      this.obsexc = '';
      this.qtdrep = '';
      this.qtdseries = '';
      this.tempodescanso = '';
    }

  }

  clearInp(): void {
    this.titref = '';
    this.opcao1 = '';
    this.arrExtras = [];
    this.obsref = '';
    this.editando = false;
  }
  goTreino(idTreino: any): void {
    //this.router.navigate(['/dashboard/treino/' + this.nickPaciente + '/' + this.idPlano + '/' + idTreino]);
  }
  
  voltar(): void{
    //this._location.back();
    if(this.tmaService.gUrlAnterior == ''){
      this.router.navigate(['/dashboard/paciente/' + this.idPaciente ]);
    }
    else{
        this.router.navigate([ this.tmaService.gUrlAnterior]);
    }
    
}

}